import { SET_LANG } from 'actions/lang'
import { HASH_CHANGED } from 'actions/visits'
import localeMapping from '../../../translations'

export const initialState = {
  locale: null,
  messages: null,
  country: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LANG: {
      return {
        ...state,
        messages: localeMapping[state.country][action.lang].messages,
        locale: localeMapping[state.country][action.lang].locale
      }
    }
    case HASH_CHANGED: {
      return {
        ...state,
        ...action.lang
      }
    }
  }
  return state
}
